module.exports = __webpack_public_path__ + "images/player1.png";